import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

interface SupportData {
  name: string;
  email: string;
  message: string;
  userId?: string | null;
}

interface SupportResponse {
  message: string;
  timestamp: string;
}

const submitSupportRequest = async (data: SupportData): Promise<SupportResponse> => {
  const response = await fetch('/api/support', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to submit support request');
  }

  return response.json();
};

export const useSupportSubmission = () => {
  const mutation = useMutation({
    mutationFn: submitSupportRequest,
    onSuccess: (data) => {
      console.log('Support request submitted successfully:', data);
    },
    onError: (error) => {
      console.error('Support submission error:', error);
      toast.error(error.message || 'Failed to submit support request');
    },
  });

  return {
    submitSupport: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
};